/* HS menu-tracking — meet welke rijen in de navigatie worden gebruikt.
   Hoort bij sections/hs-mega-navigation.liquid. Stuurt twee events:
     menu_click  — een klik op een link, met het volledige pad
     menu_open   — het menu wordt geopend of uitgeklapt, in twee smaken:
                     menu_pad "(hamburger)" = de menulade zelf wordt geopend
                     menu_pad ""            = een top-level item wordt uitgeklapt
   De events gaan UITSLUITEND naar de dataLayer; GTM zet ze door naar GA4 via de
   trigger "ce - menu_events". De tweede route via gtag() is op 23-aug-2026 verwijderd:
   twee routes naar hetzelfde event kunnen dubbel tellen, en een dubbeltelling blijft
   permanent in de historie staan terwijl een gemist event te repareren is.

   16-sep-2026: de hamburger ([data-hs-open]) viel tot nu toe buiten de meting, waardoor
   menu_open alleen drill-downs telde en we niet wisten hoe vaak de lade uberhaupt open
   ging. Bewust GEEN nieuwe eventnaam: de GTM-trigger luistert op de bestaande namen, dus
   een nieuw event zou nooit in GA4 aankomen. Scheiden doet u in GA4 op menu_pad.
   Puur meten: dit script wijzigt niets aan de navigatie zelf. */
(function () {
  "use strict";
  if (window.__hsMenuTracking) return;
  window.__hsMenuTracking = true;

  function stuur(naam, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = {};
      for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      window.dataLayer.push(Object.assign({ event: naam }, payload));
    } catch (e) {
      /* meten mag nooit de navigatie breken */
    }
  }

  function tekst(el) {
    return el && el.textContent ? el.textContent.replace(/\s+/g, " ").trim() : "";
  }

  /* Bouwt "Horlogedozen > Shop op merk > Wolf 1834" */
  function pad(link, mobiel) {
    var delen = [];
    if (mobiel) {
      var niveau = link.closest(".hs-level");
      if (niveau) {
        delen.push(tekst(niveau.querySelector(".hs-back")));
        var li = link.closest("li");
        var vorige = li ? li.previousElementSibling : null;
        while (vorige && !vorige.classList.contains("hs-level-title")) {
          vorige = vorige.previousElementSibling;
        }
        if (vorige) delen.push(tekst(vorige));
      }
    } else {
      var paneel = link.closest(".hs-nav__panel");
      if (paneel) {
        delen.push(paneel.getAttribute("aria-label") || "");
        var kolom = link.closest(".hs-nav__col");
        if (kolom) delen.push(tekst(kolom.querySelector(".hs-nav__col-title")));
      }
    }
    delen.push(tekst(link));
    return delen.filter(Boolean).join(" > ");
  }

  function positie(link) {
    var li = link.closest("li");
    if (!li || !li.parentElement) return 0;
    return Array.prototype.indexOf.call(li.parentElement.children, li) + 1;
  }

  document.addEventListener(
    "click",
    function (e) {
      var doel = e.target;
      if (!doel || !doel.closest) return;

      var link = doel.closest("a.hs-row, a.hs-nav__link, a.hs-nav__toplink, a.hs-nav__feature, a.hs-nav__account");
      if (link) {
        var mobiel = !!link.closest("[data-hs-drawer]");
        stuur("menu_click", {
          menu_variant: mobiel ? "mobiel" : "desktop",
          menu_pad: pad(link, mobiel),
          menu_label: tekst(link).slice(0, 100),
          menu_positie: positie(link),
          link_url: link.getAttribute("href") || ""
        });
        return;
      }

      var opener = doel.closest("[data-hs-into]");
      if (opener) {
        /* menu_pad en menu_positie horen niet bij een open-actie, maar blijven in de
           dataLayer staan zodra er eerder een menu_click was. Expliciet leegmaken,
           anders krijgt het open-event het pad van de vorige klik mee. */
        stuur("menu_open", {
          menu_variant: "mobiel",
          menu_label: tekst(opener).slice(0, 100),
          menu_pad: "",
          menu_positie: 0,
          link_url: ""
        });
        return;
      }

      /* De hamburger zelf. Staat buiten de lade, dus overlapt niet met [data-hs-into].
         De knop bevat alleen een icoon, vandaar een vast label. */
      var hamburger = doel.closest("[data-hs-open]");
      if (hamburger) {
        stuur("menu_open", {
          menu_variant: "mobiel",
          menu_label: "Menu openen",
          menu_pad: "(hamburger)",
          menu_positie: 0,
          link_url: ""
        });
      }
    },
    true
  );
})();
